/* eslint-disable @typescript-eslint/no-explicit-any */
import { useMonoNumbers as MonoNumbers } from '~/hooks/useMonoNumbers'
import { TableCell } from '@contensis/canvas-react'

type Props = {
  block: any
}

const MonoNumberWrap = ({ block }: Props) => {
  const processString = (text: string) => {
    const parts = MonoNumbers(text)
    return parts.map((part, ind) =>
      part.isNumber ? (
        <span key={ind} className='font-mono'>
          {part.text}
        </span>
      ) : (
        part.text
      )
    )
  }

  const processValue = (value: any): React.ReactNode => {
    if (typeof value === 'string') {
      return processString(value)
    }

    if (Array.isArray(value)) {
      return value.map((fragment: any) => {
        const type = fragment.type || fragment.properties?.type

        if (type === '_link') {
          const href =
            fragment.properties?.href || fragment.properties?.url || '#'
          return (
            <a
              key={fragment.id}
              href={href}
              className={getDecoratorClass(fragment.properties?.decorators)}
              target={fragment.properties?.target}
              rel={fragment.properties?.rel}
            >
              {processValue(fragment.value)}
            </a>
          )
        }

        return (
          <span
            key={fragment.id}
            className={getDecoratorClass(fragment.properties?.decorators)}
          >
            {processValue(fragment.value)}
          </span>
        )
      })
    }

    return null
  }

  const getDecoratorClass = (decorators: string[] | undefined): string => {
    if (!decorators) return ''
    if (decorators.includes('emphasis')) return 'italic'
    if (decorators.includes('strong')) return 'font-bold'
    if (decorators.includes('superscript'))
      return 'text-tag-sm ml-[2px] align-super'
    if (decorators.includes('subscript'))
      return 'text-tag-sm ml-[2px] align-sub'
    return ''
  }

  if (!block?.value) {
    return <TableCell.Children block={block} />
  }

  return <>{processValue(block.value)}</>
}

export default MonoNumberWrap

// const MonoNumberWrap = ({ block }: Props) => {
//   const text = block?.value
//   const parts = useMonoNumbers(typeof text === 'string' ? text : '')

//   if (typeof text !== 'string') {
//     return <TableCell.Children block={block} />
//   }

//   return parts
//     .filter(part => part.text)
//     .map((part, ind) =>
//       part.isNumber ? (
//         <span key={ind} className='font-mono'>
//           {part.text}
//         </span>
//       ) : (
//         part.text
//       )
//     )
// }

// export default MonoNumberWrap
